module.exports = __webpack_public_path__ + "assets/522006ec0634fb23d8fd9bca25556305.png";